// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen{div.footer[data-v-71930351]{display:none}}@media print{div.footer[data-v-71930351]{margin-bottom:10px;position:fixed;bottom:5px}div.footer p[data-v-71930351]{text-align:center}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
